export default "__VITE_ASSET__F23wg$xk__"